// Vendors
import React from 'react';
// Components
import { IframeComponent } from 'components/iframe/iframe.component';
// Constants
import { PROOF_INCOME_METHOD_IFRAME_PROPS } from './constants/proof-income-method.constants';
// Hooks
import { useProofIncomeMethodHook } from './hooks/proof-income-method.hook';
// Resolvers
import { getIframeUrlResolver } from './resolvers/proof-income-method.resolver';

const ProofIncomeMethodView = (): React.JSX.Element => {
  const {
    handleManageReceivedDataFromWSEvent,
    handleManageReceiveDataFromIframeEvent,
    selectedMethod,
    iframeUrl,
  } = useProofIncomeMethodHook();

  return (
    <IframeComponent
      {...PROOF_INCOME_METHOD_IFRAME_PROPS[selectedMethod]}
      onReceiveDataHandler={handleManageReceivedDataFromWSEvent}
      onEventListen={handleManageReceiveDataFromIframeEvent}
      resolver={() => getIframeUrlResolver(iframeUrl)}
    />
  );
};

export { ProofIncomeMethodView };
